/* unplugin-vue-components disabled */import script from "./SellingDrugs.vue?vue&type=script&setup=true&lang=js"
export * from "./SellingDrugs.vue?vue&type=script&setup=true&lang=js"

import "./SellingDrugs.vue?vue&type=style&index=0&id=573bdd48&lang=scss&scoped=true"
import "./SellingDrugs.vue?vue&type=style&index=1&id=573bdd48&lang=scss"

import exportComponent from "/data/jenkins/workspace/wyt-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-573bdd48"]])

export default __exports__